let FormatMixin = {
	data() {
		return {
			currency: "RUB"
		};
	},
	methods: {
		/**
		 * Форматирование цены
		 *
		 * @link https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
		 * @param price
		 * @param onlyNumber
		 * @returns {String}
		 */
		formatPrice: function (price, onlyNumber = true, currency = "RUB") {
			if (!!currency) {
				currency = this.currency;
			}

			return new Intl.NumberFormat("ru-RU", {
				style: (true === onlyNumber) ? "decimal" : "currency",
				currency: currency,
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			}).format(Number(price));
		}
	}
};

export {FormatMixin};
export default {FormatMixin};